import { render } from "./DropdownFilter.vue?vue&type=template&id=235a0daf&scoped=true"
import script from "./DropdownFilter.vue?vue&type=script&lang=js"
export * from "./DropdownFilter.vue?vue&type=script&lang=js"

import "./DropdownFilter.vue?vue&type=style&index=0&id=235a0daf&scoped=true&lang=css"

import exportComponent from "/Users/imac/projects/java/marketplace/wallet/wallet.console.web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-235a0daf"]])

export default __exports__